import IconExpandLess from '@mui/icons-material/ExpandLess';
import IconExpandMore from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { Theme } from '@mui/material/styles';
import { createStyles, makeStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import React from 'react';
import AppMenuItemComponent from '../AppMenuItemComponent/AppMenuItemComponent';

export const AppMenuItemPropTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  link: PropTypes.string,
  Icon: PropTypes.elementType,
  items: PropTypes.array,
};

type AppMenuItemsPropTypes = PropTypes.InferProps<typeof AppMenuItemPropTypes>;
type AppMenuItemPropsWithoutItems = Omit<AppMenuItemsPropTypes, 'items'>;

export type AppMenuItemProps = AppMenuItemPropsWithoutItems & {
  items?: AppMenuItemProps[];
  matchUrl?: string;
};

const AppMenuItem: React.FC<AppMenuItemProps> = (props) => {
  const { name, title, link, Icon, matchUrl, items = [] } = props;
  const classes = useStyles();
  const isExpandable = items && items.length > 0;
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    const detailPath = `/${matchUrl?.split('/')[1]}`;
    if (matchUrl && detailPath) {
      const match = items?.find((val) => {
        return val.link === detailPath;
      });
      if (match) {
        setOpen(true);
      }
    }
  }, [matchUrl, link, items]);

  function handleClick() {
    setOpen(!open);
  }

  const MenuItemRoot = (
    <AppMenuItemComponent
      className={classes.menuItem}
      link={link}
      onClick={handleClick}
    >
      {!!Icon && (
        <ListItemIcon>
          <Icon color="primary" />
        </ListItemIcon>
      )}
      <ListItemText primary={title} inset={!Icon} />
      {isExpandable && !open && <IconExpandMore />}
      {isExpandable && open && <IconExpandLess />}
    </AppMenuItemComponent>
  );

  const MenuItemChildren = isExpandable ? (
    <Collapse in={open} timeout="auto" unmountOnExit>
      <Divider />
      <List component="div" disablePadding>
        {items.map((item, index) => (
          <AppMenuItem {...item} key={index} />
        ))}
      </List>
    </Collapse>
  ) : null;

  return (
    <>
      {MenuItemRoot}
      {MenuItemChildren}
    </>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    menuItem: {
      '&.active': {
        background: 'rgb(0 98 245 / 8%)',
        '& .MuiListItemIcon-root': {
          color: '#fff',
        },
      },
    },
  })
);

export { AppMenuItem };
